<template lang="pug">
  app-page(title="Управление группами" :fab-items="items")
    app-toolbar(title="Управление группами специалистов")

    addGroup(v-model="dialogAddGroup" :group.sync="group")

    // SpecGroup list 
    //
    div
      v-layout(row wrap v-if="groups.length > 0")
        v-flex.px-4(xs4 v-for="(a, index) in groups" :key="index"  )
          app-card(@click.native="selectItem(a)")
            app-card-header 
              | {{ a.groupName }}
            app-card-body
              app-card-title 
                | Специалистов: {{ a.specialistCount }}
              app-card-caption.mt-2(v-if="a.bankAccount") 
                | Банк получателя: {{ a.bankAccount.bank }} <br/>
                | Счет получателя: {{ a.bankAccount.bill }} <br/>
                | ИНН получателя: {{ a.bankAccount.inn }}

</template>

<script>
import { AppToolbarItemDivider } from '@/components'
import { mapGetters } from 'vuex';
import addGroup from './components/AddGroup'

export default {
  components: {
    addGroup
  },

  methods: {
    selectItem (item) {
      this.group = item
      this.dialogAddGroup = true
    },

    addItem () {
      this.group = null
      this.dialogAddGroup = true
    },
  },

  data() {
    return {
      dialogAddGroup: false,
      group: null,
      items: [
        AppToolbarItemDivider,
        {icon:'sud-add-icon sud-add-message', title:'группу', action: () => this.addItem() },
        {icon:'person', title:'Модерация специалистов', action: () => this.$router.push({name: 'SpecialistManage'}) }, 
      ]
    }
  },


  computed: {
    ...mapGetters('specialist', ['groups','isGroupsLoaded']),
  },
  created() {
    this.$store.dispatch('specialist/LOAD_GROUPS')
  }
}


</script>

<style scoped>
</style>
